import '../App.css';

import DropFileInput from '../components/drop-file-input/DropFileInput';

function DragnDrop() {

    const onFileChange = (files) => {
        console.log(files);
    }

    return (
        <div className="box">
            <h2 className="header">
               Drag .xlsx and Drop Here
            </h2>
            <DropFileInput
                onFileChange={(files) => onFileChange(files)}
            />
        </div>
    );
}

export default DragnDrop;
